const braves_themes = {
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.8)',
      banner_text: '#ffffff',
      banner_section: '#ffffff',
      banner_subtitle: 'rgba(255, 255, 255, 0.9)',
      banner_mins: 'rgba(255, 255, 255, 1.0)',
      grid_section: '#ffffff',
      grid_subtitle: 'rgba(255, 255, 255, 0.8)',
      grid_mins: 'rgba(255, 255, 255, 1.0)',
    },
    
    logo: {
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      borderRadius: 'clamp(0.8rem, 1.5vw, 1.25rem)',
      background: 'transparent',
      padding: '0',
    },

    background: {
      primary: 'linear-gradient(135deg, #13274F 0%, #1a3260 100%)',
      banner: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 100%, rgba(0, 0, 0, 0.2) 100%)',
      banner_here: '#CE1141',
      grid: 'linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 0%)',
    }
  };
  
  export default braves_themes;